import Highcharts from "highcharts";
import {
  CHART_LABEL_FONT_SIZE,
  CHART_SERIES,
  CHARTS_SHARED_OPTIONS,
  SeriesNames,
} from "../../../constants/charts";
import { FONT_COLORS } from "../../../constants";

export const OFFERS_CHART_DEFAULT_OPTIONS: Highcharts.Options = {
  ...CHARTS_SHARED_OPTIONS,
  chart: {
    ...CHARTS_SHARED_OPTIONS.chart,
    height: 150,
  },
  legend: {
    ...CHARTS_SHARED_OPTIONS.legend,
    padding: 4,
    itemDistance: 8,
  },
  plotOptions: {
    ...CHARTS_SHARED_OPTIONS.plotOptions,
    series: {
      ...CHARTS_SHARED_OPTIONS.plotOptions?.series,
      states: {
        ...CHARTS_SHARED_OPTIONS.plotOptions?.series?.states,
        hover: {
          lineWidth: 1,
        },
        inactive: {
          opacity: 1,
        },
      },
      marker: {
        ...CHARTS_SHARED_OPTIONS.plotOptions?.series?.marker,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },
  yAxis: [
    {
      title: {
        text: "",
      },
      labels: {
        x: -4,
        style: {
          fontSize: CHART_LABEL_FONT_SIZE,
          color: FONT_COLORS.label,
        },
      },
    },
    // This is a secondary y-axis used for displaying Rating data
    {
      title: {
        text: "",
      },
      labels: {
        enabled: false,
      },
    },
    // This is a third y-axis used for displaying Review Count data
    {
      opposite: true,
      title: {
        text: "",
      },
      labels: {
        x: 4,
        style: {
          fontSize: CHART_LABEL_FONT_SIZE,
          color: FONT_COLORS.label,
        },
        formatter: ({ value }) =>
          "#" + (value >= 1000 ? `${+value / 1000}k` : value),
      },
    },
  ],
  series: [
    {
      ...CHART_SERIES[SeriesNames.OffersCount],
      type: "line",
    },
    {
      ...CHART_SERIES[SeriesNames.Rating],
      type: "line",
      yAxis: 1, // Uses the secondary y-axis configured in OFFERS_CHART_DEFAULT_OPTIONS for displaying Rating data
    },
    {
      ...CHART_SERIES[SeriesNames.ReviewCount],
      type: "line",
      yAxis: 2, // Uses the third y-axis configured in OFFERS_CHART_DEFAULT_OPTIONS for displaying Review Count data
    },
  ],
};
